import { parser as TextParser } from './Blocks/Text';
import { parser as VideoParser } from './Blocks/Video';

const parsers: {[ key: string ]: any} = {
    text: TextParser,
    video: VideoParser,
}

export default parsers;
